var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgEntitySuspect = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 48,
  viewBox: "0 -960 960 960",
  width: 48,
  fill: "#EA3323"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M331.15-280.87 480-429.72l148.85 148.85 50.28-50.28L530.28-480l148.85-148.85-50.28-50.28L480-530.28 331.15-679.13l-50.28 50.28L429.72-480 280.87-331.15l50.28 50.28ZM479.57-62.8q-85.45 0-161.64-32.92-76.2-32.93-132.74-89.47-56.54-56.54-89.47-132.83-32.92-76.3-32.92-161.95 0-86.54 32.98-162.65 32.98-76.12 89.81-132.94 56.83-56.82 132.74-89.35 75.92-32.52 161.17-32.52 86.63 0 163.08 32.5 76.46 32.51 133.04 89.3 56.58 56.8 89.2 133.09 32.61 76.3 32.61 163.08 0 85.77-32.52 161.42-32.53 75.65-89.35 132.46-56.82 56.82-133.05 89.8Q566.28-62.8 479.57-62.8Zm.38-77.31q141.13 0 240.53-99.7 99.41-99.7 99.41-240.14 0-141.13-99.35-240.53-99.35-99.41-240.6-99.41-140.26 0-240.04 99.35-99.79 99.35-99.79 240.6 0 140.26 99.7 240.04 99.7 99.79 240.14 99.79ZM480-480Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 480,
  cy: -480,
  r: 440,
  fill: "#fff",
  fillOpacity: 0.1
})));

export { SvgEntitySuspect as ReactComponent };
export default __webpack_public_path__ + "dd24f15bd1c068e64221d3efe32f368a.svg";